import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common'
import { ModuleWithProviders, NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { MaterialModule } from '@app/plugins/material/material.module'
import { CKEditorModule } from '@ckeditor/ckeditor5-angular'
import { CommentableComponent } from '@shared/components/commentable/commentable.component'
import { DescriptionEditorComponent } from '@shared/components/description-editor/description-editor.component'
import { NotificationSidebarComponent } from '@shared/components/notification-sidebar/notification-sidebar.component'
import { ConvertCurrencyPipe } from '@shared/pipe/convertCurrency.pipe'
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha'
import { ErrorComponent } from './components/error/error.component'
import { LoaderModalModule } from './components/loader-modal/loader-modal.module'
import { MaintenanceComponent } from './components/maintenance/maintenance.component'
import { MessageDisplayComponent } from './components/message-display/message-display.component'
import { NotFoundComponent } from './components/not-found/not-found.component'
import { ScopeUiGoBackBreadcrumbComponent } from './components/scope-ui-go-back-breadcrumb/scope-ui-go-back-breadcrumb.component'
import { TableLoaderComponent } from './components/ui-components/table-loader/table-loader.component'
import { UnauthorisedComponent } from './components/unauthorised/unauthorised.component'
import { DirectivesModule } from './directives/index.module'
import { PipesModule } from './pipe/index.module'

@NgModule({
  declarations: [
    NotFoundComponent,
    MaintenanceComponent,
    UnauthorisedComponent,
    MessageDisplayComponent,
    ErrorComponent,
    DescriptionEditorComponent,
    CommentableComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    DirectivesModule,
    LoaderModalModule,
    ReactiveFormsModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    MaterialModule,
    FormsModule,
    PipesModule,
    ScopeUiGoBackBreadcrumbComponent,
    CKEditorModule,
    NotificationSidebarComponent,
    TableLoaderComponent,
  ],
  exports: [
    LoaderModalModule,
    PipesModule,
    DirectivesModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    DatePipe,
    CurrencyPipe,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    MessageDisplayComponent,
    DescriptionEditorComponent,
    CommentableComponent,
    TableLoaderComponent,
  ],
  providers: [ConvertCurrencyPipe],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return { ngModule: SharedModule }
  }
}
